import { SupportedSubdivisionCode } from '../constants/companyConstants';

const UK_ADMIN_AREA_TO_SUBDIVISION: Record<string, SupportedSubdivisionCode> = {
	England: 'GB-ENG',
	Scotland: 'GB-SCT',
	Wales: 'GB-WLS',
	'Northern Ireland': 'GB-NIR',
};

/**
 * Converts a Google Places administrative_area_level_1 long_name to an
 * ISO 3166-2 subdivision code. Only meaningful for GB ('gb') addresses.
 * Returns undefined for non-GB countries or unrecognised areas.
 */
export function googlePlacesAdminAreaToSubdivision(
	adminAreaLongName: string | undefined,
	internalCountryCode: string,
): SupportedSubdivisionCode | undefined {
	if (internalCountryCode !== 'gb' || !adminAreaLongName) return undefined;
	return UK_ADMIN_AREA_TO_SUBDIVISION[adminAreaLongName];
}
